module.exports = __webpack_public_path__ + "img/sunshine_coast_funeral-memorial.ea89547c.jpg";